/**
 * This file was auto-generated by Fern from our API Definition.
 */
export const GetSpacesSortField = {
    Name: "name",
    WorkbooksCount: "workbooksCount",
    FilesCount: "filesCount",
    EnvironmentId: "environmentId",
    CreatedByUserName: "createdByUserName",
    CreatedAt: "createdAt",
    LastActivityAt: "lastActivityAt",
};
